import React from "react";

export default function LineSignShape({
  increasing = true,
  zeroLabel = "0",
  leftSign = "-",
  rightSign = "+",
  width = 360,
  height = 180,
  axisColor = "currentColor",
  lineColor = "var(--color-accent, #f59e0b)",
  textColor = "var(--color-accent, #f59e0b)",
}) {
  const pad = 26;
  const leftX = pad;
  const rightX = width - pad;
  const xAxisY = height / 2 + 10;
  const zeroX = width / 2;

  const slopeSpan = 110;
  const slopeDrop = 48;
  const startX = zeroX - slopeSpan;
  const endX = zeroX + slopeSpan;
  const startY = increasing ? xAxisY + slopeDrop : xAxisY - slopeDrop;
  const endY = increasing ? xAxisY - slopeDrop : xAxisY + slopeDrop;

  const arrow = 10;
  const tick = 5;

  const signRadius = 11;
  const leftSignX = zeroX - 84;
  const rightSignX = zeroX + 84;
  const signAxisOffset = 16;
  const leftSignY = leftSign === "+" ? xAxisY - signAxisOffset : xAxisY + signAxisOffset;
  const rightSignY = rightSign === "+" ? xAxisY - signAxisOffset : xAxisY + signAxisOffset;

  const SignBadge = ({ x, y, sign }) => (
    <g>
      <circle
        cx={x}
        cy={y}
        r={signRadius}
        fill="none"
        stroke={textColor}
        strokeWidth="2"
      />
      <text
        x={x}
        y={y}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={sign === "+" ? "18" : "20"}
        fontWeight="700"
        fontFamily="KaTeX_Main, STIXGeneral, 'Times New Roman', serif"
        fill={textColor}
      >
        {sign}
      </text>
    </g>
  );

  return (
    <svg viewBox={`0 0 ${width} ${height}`} width="100%" height={height} role="img">
      <line x1={leftX} y1={xAxisY} x2={rightX} y2={xAxisY} stroke={axisColor} strokeWidth="2" />
      <path
        d={`M ${rightX - arrow} ${xAxisY - arrow / 2} L ${rightX} ${xAxisY} L ${rightX - arrow} ${xAxisY + arrow / 2} Z`}
        fill={axisColor}
      />

      <line x1={zeroX} y1={xAxisY - tick} x2={zeroX} y2={xAxisY + tick} stroke={axisColor} strokeWidth="2" />

      <line
        x1={startX}
        y1={startY}
        x2={endX}
        y2={endY}
        stroke={lineColor}
        strokeWidth="3"
        strokeLinecap="round"
      />

      <text
        x={zeroX}
        y={xAxisY + 18}
        textAnchor="middle"
        dominantBaseline="hanging"
        fontSize="18"
        fontFamily="KaTeX_Main, STIXGeneral, 'Times New Roman', serif"
        fill="currentColor"
      >
        {zeroLabel}
      </text>

      <SignBadge x={leftSignX} y={leftSignY} sign={leftSign} />
      <SignBadge x={rightSignX} y={rightSignY} sign={rightSign} />
    </svg>
  );
}
